
import { AXIOS } from "customAxios";
import { ListByRouteNumberOrNameRequest } from "features/Client/RouteManagement/ServiceStopMaintenance/types";
import { ValidateUSPSAddress } from "hooks/useValidateAddress";
export interface Account {
  accountNameNumberStr: string;
  accountNumber: string;
}

export interface ListAccountsByNumberOrNameResponse {
  content: Account[];
  totalElements: number;
  totalPages: number;
  first: boolean;
  last: boolean;
}

export async function getSubClientAssignedPermissions({ subClientId }: { subClientId: string | number; }) {
  return await AXIOS.get('/api/client/common/subClientAssignedPermissions', {
    params: {
      subClientId
    }
  });
}

export async function reportError(data: FormData) {
  return await AXIOS.post('/auth/reportError', data, {
    headers: {
      clientId: '-1'
    }
  });
}

export async function validateUSPSAddress(data: ValidateUSPSAddress & { clientId: string }) {
  return await AXIOS.post('/api/master/validateUspsAddress', data);
}


export const getListAccountsByNumberOrName = async ({
  sortBy,
  orderBy,
  page,
  pageSize,
  searchText,
  subClientId,
  accountType
}: {
  sortBy: string;
  orderBy: string;
  page: number;
  pageSize: string;
  searchText: string;
  subClientId: string;
  accountType?: string;
}) => {
  return await AXIOS.get('/api/master/listAccountsByNumberOrName', {
    params: {
      sortBy,
      orderBy,
      page,
      size: pageSize,
      searchText,
      subClientId,
      accountType
    },
  });
};

export const getListTicketNumbers = async ({
  sortBy,
  orderBy,
  page,
  pageSize,
  searchText,
  subClientId,
}: {
  sortBy: string;
  orderBy: string;
  page: number;
  pageSize: string;
  searchText: string;
  subClientId: string;
}) => {
  return await AXIOS.get('/api/master/listTicketNumbers', {
    params: {
      sortBy,
      orderBy,
      page,
      size: pageSize,
      searchText,
      subClientId,
    },
  });
};


export const getUtilityData = async (userData: {
  fetchCurrentDate: boolean;
  fetchCurrentTime: boolean;
}) => {
  return await AXIOS.post('/api/master/fetchUtilityData', userData);
}

export const getSubClientDetails = async (userData: { subClientId: string; }) => {
  return await AXIOS.get('/api/client/common/fetchSubClientDetails', {
    params: userData
  });
}

export const getListByRouteNumberOrName = async ({
  sortBy,
  orderBy,
  page,
  pageSize,
  searchText,
  fetchUserAssignedRoutes,
  clientId,
  sequenceType
}: ListByRouteNumberOrNameRequest) => {
  return await AXIOS.get('/api/master/listRoutesByNumberOrName', {
    params: {
      sortBy,
      orderBy,
      page,
      size: pageSize,
      searchText,
      clientId,
      fetchUserAssignedRoutes,
      sequenceType
    },
  });
};


export async function reloadSystemCache() {
  return await AXIOS.post('/api/super/reloadSystemCache');
}
